// removed by extract-text-webpack-plugin
module.exports = {"Users":"User__Users__2iGHC","User":"User__User__1vbr0","UserImage":"User__UserImage__pCZfy","IsActive":"User__IsActive__3BBCi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/User/User.css
// module id = 389
// module chunks = 0